<div class="vds-status-wrapper">
    <span class="vds-status-content">
        @if (leadingIcon()) {
            <ng-container *polymorpheusOutlet="leadingIcon() as primitive">
                <vds-icon [name]="primitive" />
            </ng-container>
        } @else {
            @if (!simple()) {
                <span class="vds-status-circle" [class.vds-status-circle--filled]="fill()"></span>
            }
        }
        <ng-content />
    </span>
</div>
